import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSubmitQuizMutation } from "../../../features/quiz/quizApi";
import { areAllAnswersProvided } from "../../../utils/areAllAnswersProvided";
import { quizMarkCalculator } from "../../../utils/quizMarkCalculator";
import QuizItem from "./QuizItem";
import { v4 as uuid } from 'uuid';

const QuizList = ({ quizzes }) => {
 const navigate = useNavigate();


  const {
    user: { id, name },
  } = useSelector((state) => state.auth);
  const { answers } = useSelector((state) => state.quiz);
  const { video_id, video_title } = quizzes[0];
  const [submitQuiz, {isSuccess}] = useSubmitQuizMutation();


  useEffect(() => {
    if(isSuccess){
        navigate('/leaderboard')
    }
  },[isSuccess])

  const handleSubmit = () => {

    const checkAnswers = areAllAnswersProvided(Object.values(answers))

    if(checkAnswers){
        const { totalCorrect, totalMark, totalWrong } = quizMarkCalculator(answers);

        const data = {
            id: uuid(),
            student_id: id,
            student_name: name,
            video_id,
            video_title,
            totalQuiz: quizzes?.length,
            totalCorrect,
            totalWrong,
            totalMark,
          };
        submitQuiz(data)
    }else{
      toast.error("Please provide all the answers!")
    }
  };

  return (
    <div className="space-y-8 ">
      {quizzes.map((quiz, index) => (
        <QuizItem key={quiz.id} quiz={quiz} index={index} />
      ))}
      <button
        className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95 "
        onClick={handleSubmit}
        
      >
        Submit
      </button>
    </div>
  );
};

export default QuizList;
